import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';
import {
  incrementStreamActivities,
  decrementStreamActivities,
  resetStreamActivities,
  incrementStreamNotifications,
  decrementStreamNotifications,
  resetStreamNotifications,
  resetStreamAlerts,
} from '../../redux/notifications';

const DEBOUNCE_DELAY = 250;

/**
 * Hook for dispatching global notifications
 */
export const useNotifications = () => {
  const streamActivities = useSelector<{ notifications: { stream: { activity: number } } }, number>(
    (state) => state.notifications.stream.activity
  );
  const streamNotifications = useSelector<
    { notifications: { stream: { notifications: number } } },
    number
  >((state) => state.notifications.stream.notifications);

  const dispatch = useDispatch();

  const incrementStreamActivityCount = useCallback(() => dispatch(incrementStreamActivities()), [
    dispatch,
  ]);
  const decrementStreamActivityCount = useCallback(() => dispatch(decrementStreamActivities()), [
    dispatch,
  ]);
  const resetStreamActivityCount = useCallback(() => dispatch(resetStreamActivities()), [dispatch]);
  const incrementStreamNotificationsCount = useCallback(
    () => dispatch(incrementStreamNotifications()),
    [dispatch]
  );
  const decrementStreamNotificationsCount = useCallback(
    () => dispatch(decrementStreamNotifications()),
    [dispatch]
  );
  const resetStreamNotificationsCount = useCallback(() => dispatch(resetStreamNotifications()), [
    dispatch,
  ]);
  const resetStreamAlertCount = useCallback(() => dispatch(resetStreamAlerts()), [dispatch]);

  return {
    streamActivities,
    streamNotifications,
    totalStreamAlerts: streamActivities + streamNotifications,
    incrementStreamActivityCount: debounce(incrementStreamActivityCount, DEBOUNCE_DELAY),
    decrementStreamActivityCount: debounce(decrementStreamActivityCount, DEBOUNCE_DELAY),
    resetStreamActivityCount: debounce(resetStreamActivityCount, DEBOUNCE_DELAY),
    incrementStreamNotificationsCount: debounce(incrementStreamNotificationsCount, DEBOUNCE_DELAY),
    decrementStreamNotificationsCount: debounce(decrementStreamNotificationsCount, DEBOUNCE_DELAY),
    resetStreamNotificationsCount: debounce(resetStreamNotificationsCount, DEBOUNCE_DELAY),
    resetStreamAlertCount: debounce(resetStreamAlertCount, DEBOUNCE_DELAY),
  };
};
